import isTruthy from '@/utils/is-truthy'

const safeEmpty = data => (isTruthy(data) ? data : '')

export const safeEmptySpace = data => (isTruthy(data) ? data : '&#160;')

export default safeEmpty
